import { CustomAccountSelect } from 'components/custom-ui/CustomSelect';
import DateSelect from 'components/custom-ui/DateSelect';
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { useStateManager } from "bcms-react";
import "./styles.css";
import Classes, { Account } from "model";

/**
 * @function MultiWireTable
 * @return {React.Component}
 * @exported true
 * @description The table that shows the multi wires
 */

export default function MultiWireTable(props) {
  const { onChange } = useStateManager();
  const wire = props.wire ?? {};
  const payeeType = wire.payee.payeeType.charAt(0).toUpperCase() + wire.payee.payeeType.slice(1);

  return(
    <TableView className="multi-wire-table">
      {/* colgroup is needed for table layout */}
      <colgroup>
        <col span="1" />
        <col span="1" />
        <col span="1" />
        <col span="1" />
        <col span="1" />
      </colgroup>
      <thead className="table-column-container">
        <tr>
          <th className="text-left table-column-view" colSpan="2">Payee Nickname</th>
          <th className="text-left table-column-view">Payee Name</th>
          <th className="text-left table-column-view" colSpan="2">Wire Date</th>
        </tr>
      </thead>

      <TableBody>
        <tr className="table-item-container">
          <td className="table-item-view"><b>{ wire.payee.nickname }</b></td>
          <td className="table-item-view"></td>
          <td className="table-item-view"><b>{ wire.payee.name }</b></td>
          <td className="table-item-view" colSpan="2"><DateSelect value={ wire.wireDate } onChange={ onChange("wireDate", wire) } /></td>
        </tr>
        <tr className="table-item-container">
          <td className="table-item-view"><p>Type:</p></td>
          <td className="table-item-view"><b>{ payeeType }</b></td>
          <td className="table-item-view"></td>
          <td className="table-item-view"></td>
          <td className="table-item-view"></td>
        </tr>
        <tr className="table-item-container">
          <td className="table-item-view"><p>Account:</p></td>
          <td className="table-item-view">
            <CustomAccountSelect value={ wire.fundingAccount } accounts={ Account.initAllAsset() } onChange={ onChange("fundingAccount", wire) } />
          </td>
          <td className="table-item-view">
            <div className="flex-container flex-horizontal align-center">
              <p className="left-inline-label set-width">Amount:</p>
              <UIAmountInput value={ wire.amount.amount === "" ? undefined : wire.amount.format({style:"decimal"}) } onBlur={ onChange("amount", wire) } />
            </div>
          </td>
          <td className="table-item-view">
            <div className="flex-container flex-horizontal align-center">
              <p className="left-inline-label set-width">Last:</p>
              <b className="flex-width">N/A</b>
            </div>
          </td>
          <td className="table-item-view">
            <div className="flex-container flex-horizontal align-center">
              <p className="left-inline-label set-width">Scheduled:</p>
              <b className="flex-width">N/A</b>
            </div>
          </td>
        </tr>
        <tr className="table-item-container">
          <td className="table-item-view"><p>Memo:</p></td>
          <td className="table-item-view" colSpan="2">
            <UITextInput value={ wire.memo } onBlur={ onChange("memo", wire) } />
          </td>
          <td className="table-item-view"></td>
          <td className="table-item-view"></td>
        </tr>
      </TableBody>
    </TableView>
  );
}